import React from 'react';
import {graphql} from 'gatsby';
import get from 'lodash/get';

import GenericHeading from 'ssg-themes/src/themes/hellofinance/modules/GenericHeading/GenericHeading';
import RecentPosts from 'ssg-themes/src/themes/hellofinance/modules/RecentPosts/RecentPosts';
import GenericTeam from 'ssg-themes/src/themes/hellofinance/modules/GenericTeam/GenericTeam';
import TeamContent from 'ssg-themes/src/themes/hellofinance/modules/TeamContent/TeamContent';

import {parseArticleLong} from '../../utils/parseArticles';
import parseAuthor from '../../utils/parseAuthor';
import Seo from "../../components/Seo/Seo";
import Base from "../../templates/base";

import data from '../../data/redakcja.data';

const TeamPage = props => {
  const contentfulBlogPost = get(props, 'data.allContentfulBlogPost.edges');
  const allAuthors = get(props, 'data.allAuthors.nodes');
  const restAllAuthors = get(props, 'data.restAllAuthors.nodes');

  const authors = allAuthors.map(node => parseAuthor(node))
  const restAuthors = restAllAuthors.map(node => parseAuthor(node))
  const recentPosts = contentfulBlogPost.map(({node}) => parseArticleLong(node));

  return <Base headerVariant='Dark' hasHeaderFixedWidth={true}>
    <Seo {...data.seo} />
    <GenericHeading {...data.genericHeading}/>
    <TeamContent {...data.teamContent} />
    <GenericTeam heading="Redakcja" authors={authors}/>
    <GenericTeam heading="Recenzenci merytoryczni" authors={restAuthors} isHiddenMobile={true}/>
    {recentPosts.length > 0 && <RecentPosts heading="Najnowsze artykuły" articles={recentPosts} variant="LightGray"/>}
  </Base>;
};

export default TeamPage;

export const pageQuery = graphql`
  query GetPostsForTeam {
    restAllAuthors: allContentfulAuthor(
      filter: {role: {nin: ["Redaktorka HelloFinance", "Redaktor HelloFinance", "Fact-checker"]}}
    ) {
      nodes {
        ...authorFields
      }
    }
    allAuthors: allContentfulAuthor(
      filter: {role: {in: ["Redaktorka HelloFinance", "Redaktor HelloFinance"]}}
    ) {
      nodes {
        slug
        hasAuthorPage
        ...authorFields
      }
    }
    allContentfulBlogPost(
      limit: 6
      filter: {slug: {ne: null}, options:{nin: "Hide in listing"}}
      sort: {createdAt: DESC}
    ) {
      edges {
        node {
          thumbnailImage {
            url
          }
          node_locale
          id
          options
          slug
          heading
          shortHeading
          content {
            content
          }
          shortContent
          createdAt(locale: "pl", formatString: "DD MMMM, YYYY")
          rawDate: createdAt
          category {
            slug
            heading
            shortHeading
          }
          seo {
            title
          }
        }
      }
    }
  }
`;
